// 缓存key映射
export enum COOKIE_KEY {
  USER_TOKEN = 'youyan-user-token',
  USER_RIGHTS = 'youyan-user-rights',
  LOCALE = 'i18n_redirected',
  TIMEZONE = 'x-timezone',
  USER_RANDOM_ID = 'youyan-user-random-id',
  COMPATIBILITY_HINT = 'compatibility-hint',
}

export enum BROADCAST_KEY {
  REFRESH = 'youyan-refresh',
}

// 其他通知
export enum CHANNEL_TYPE {
  BUY_STORAGE = 'youyan-buy-storage', // 存储空间购买
}

export const SESSION_SOURCE = 'session_source'
export const SESSION_REF = 'session_ref'
export const SESSION_QUERY_PASSTHROUGH = 'session_query_passthrough'
export const SESSION_PPT = 'session_ppt' // ppt世界 活动链接
export const SESSION_SHANDONG = 'session_shandong' // 山东活动链接

export const INVITE_CODE = 'invite_code' // 邀请码
export const DISCOUNT_CODE = 'discount_code' // 优惠码

export const UPDATE_PROJECT_SHOW = 'update_project_show' // 右下角产品更新提示

export const YY_COMMON_GENERATE_LIST = 'yy_common_generate_list' // 任务中心 channel

// localstorage key
export enum LOCAL_KEY {
  CREATE_WORK = 'manual_nav', // 跳转到3D生成+演播室
  UPDATE_USERINFO = 'update_userinfo', // 通知编辑器更新用户
}

export enum SESSION_KEY {
  CHARACTER_SOURCE = 'character_source',
}
